import React, { useCallback, useMemo,useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  Button,
  ModalHeader,
  ModalOverlay,
  Box,
} from "@chakra-ui/react";
import { Col, Row } from "react-bootstrap";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { fetchAsyncResourcePONum } from "redux/tdsSlice";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { useDispatch, useSelector } from "react-redux";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import SpentAmountTable from "./dataChangeTable/spentAmount";
import RefundAmountTable from "./dataChangeTable/refundAmountTable";

const TdsDataChangeModal = ({
  openModal,
  closeModal,
  editData,
  currentData,
  isConfirmed,
  type,
  role
}) => {
  const vendorList = useSelector((state) => state.vendorData);
  const dispatch = useDispatch();

    const getcurrectData = Object.fromEntries(
      Array.from(currentData?.entries() || []).map(([key, value]) => [
        key,
        key === "payInfo" ? JSON.parse(value) : value,
      ])
    );

    const [currentPo, setCurrentPo] = useState('');
    const [editPo, setEditPo] = useState('');
    
    const fetchResourcePo = (referenceResourcePO, type) => {
      dispatch(fetchAsyncResourcePONum()).then((res) => {
        if (res.payload) {
          const resourcePoNo = res.payload.map(item => ({
            _id: item._id,
            poNo: poNumberFormate(item.poNo),
          }));
    
          const obj = resourcePoNo.find(item => item._id === referenceResourcePO);
          const pono = obj?.poNo || '';
    
          if (type === 'current') {
            setCurrentPo(pono);
          } else if (type === 'edited') {
            setEditPo(pono);
          }
        }
      });
    };

    (function() {
      if (getcurrectData?.refResourcePONum) {
        fetchResourcePo(getcurrectData.refResourcePONum, 'edited');
      }
      if (editData?.rfPo) {
        fetchResourcePo(editData.rfPo, 'current');
      }
    })(); 

    const currentSpentInfo = useMemo(() => {
      if (getcurrectData?.payInfo) {
        return getcurrectData.payInfo.map(item => item);
      }
      return [];
    }, [getcurrectData]);
  
    const editSpentInfo = useMemo(() => {
      if (editData?.pyInfo?.list) {
        const currSpentData = getcurrectData?.payInfo || [];
        const spentData = editData.pyInfo.list || [];
        const dummObjectCount = currSpentData.length - spentData.length;
  
        return [
          ...spentData,
          ...Array(Math.max(0, dummObjectCount)).fill({}),
        ];
      }
      return [];
    }, [getcurrectData, editData]);
  
    const currentRefundInfo = useMemo(() => {
      if (getcurrectData?.refundInfo) {
        const refundData = JSON.parse(getcurrectData.refundInfo) || [];
        return refundData.map(item => item);
      }
      return [];
    }, [getcurrectData]);
  
    const editRefundInfo = useMemo(() => {
      if (editData?.rfdInfo?.list) {
        const refundData = editData.rfdInfo.list || [];
        const currrefundData = JSON.parse(getcurrectData?.refundInfo || '[]') || [];
        const dummObjectCount = currrefundData.length - refundData.length;
  
        return [
          ...refundData,
          ...Array(Math.max(0, dummObjectCount)).fill({}),
        ];
      }
      return [];
    }, [getcurrectData, editData]);

  const fetchResourceName = useCallback((vendorId) => {
    const filteredVendors = vendorList.filter(vendor => vendor.isC === true);

    const vendor = filteredVendors.find((vendor) => vendor._id === vendorId);
    
    if (vendor) {
      return vendor.name; 
    } else {
      return ""; 
    }
  }, [vendorList]);

  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={closeModal}
        size="xl"
        className="modal-main data-change-model"
        scrollBehavior={"inside"}
        
      >
        <ModalOverlay />
        <ModalContent 
         top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
        className="data-change-content info-model"
>
          <ModalHeader className="expense-modal-header data-change-modal-header">
            <>
              {/* Compare fields */}
              <Row className="modal-header-row">
                <Col>
                  <h6>
                    Current
                  </h6>
                </Col>
                
                <Col>
                  <h6 >
                    Edited
                  </h6>
                </Col>
              </Row>
            </>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="mt-0">
            <Row>
              <Col className="row-col">
                <div className="row-table">
                  <Row className="rowC">
                        <h4 className="row-heading">
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(editData.Om)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Order Date : {dateTimeFormat(editData.oDt)}</Col>
                  </Row>
                 
                    <Row className="rowC">
                        <Col className={`${editData?.rfPo !== getcurrectData?.refResourcePONum  ? 'data_compare_red' : '' }`}>Reference Resource PO  : {currentPo}</Col>
                      </Row>
                  <Row className="rowC">
                        <Col className={`${editData?.resId?._id !== getcurrectData?.resourceId  ? 'data_compare_red' : '' }`}>Resource Name : {fetchResourceName(editData?.resId?._id)}</Col>
                    </Row>
                  <Row className="rowC">
                        <Col className={`${editData?.pnNo !== getcurrectData?.panNumber  ? 'data_compare_red' : '' }`}>Pan Number : {editData?.pnNo}</Col>
                    </Row>
                
                      
                     
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_red' : '' }`}>Remarks : {editData.rmks}</Col>
                      </Row>
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          TDS Information:
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.tlBlAmt || 0) !== Number(getcurrectData.totalAmount || 0)  ? 'data_compare_red' : '' }`}>
                          <Box display="flex">Total Amount : {formatAmountInINR(parseFloat(editData?.tlBlAmt || 0))}</Box>
                        </Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.prc) !== Number(getcurrectData.tdsPercent)  ? 'data_compare_red' : '' }`}>
                          TDS Percent : {editData?.prc}
                        </Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.tdsAmt) !== Number(getcurrectData.tdsAmount)  ? 'data_compare_red' : '' }`}>
                        <Box display="flex"> TDS Amount : {(formatAmountInINR(parseFloat(parseFloat(editData?.tdsAmt || 0))))} </Box>
                        </Col>
                      </Row>
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information : 
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.approvalAmount || 0)  ? 'data_compare_red' : '' }`}>
                            <Box display="flex">
                            Requested Amount : {formatAmountInINR(editData?.pyInfo?.apAmt)}
                            </Box>
                        </Col>
                      </Row>

                     <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="current" />
                 
                 
               

                    

                     {(role === "Manager" || role === "Admin") &&
                     <>
                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="current"/>
                     </>
}
                  
                     
                      
                  
                  
                   
                </div>
              </Col>
              <Col className="row-col">
                <div className="row-table">
                <Row className="rowC">
                        <h4
                         className="row-heading"
                        >
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(getcurrectData.orderMonth)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>
                      Order Date : {dateTimeFormat(getcurrectData.orderDate)}
                    </Col>
                  </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.rfPo !== getcurrectData?.refResourcePONum  ? 'data_compare_green' : '' }`}>Reference Resource PO : {editPo}</Col>
                      </Row>
                  <Row className="rowC">
                        <Col className={`${editData?.resId?._id !== getcurrectData?.resourceId  ? 'data_compare_green' : '' }`}>Resource Name : {fetchResourceName(getcurrectData?.resourceId)}</Col>
                    </Row>
                  <Row className="rowC">
                        <Col className={`${editData?.pnNo !== getcurrectData.panNumber  ? 'data_compare_green' : '' }`}>Pan Number : {getcurrectData?.panNumber}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_green' : '' }`}>Remarks : {getcurrectData.remarks}</Col>
                      </Row>
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          TDS Information :
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.tlBlAmt || 0) !== Number(getcurrectData.totalAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">Total Amount : {formatAmountInINR(parseFloat(getcurrectData.totalAmount || 0))}</Box></Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.prc || 0) !== Number(getcurrectData.tdsPercent || 0)  ? 'data_compare_green' : '' }`}>TDS Percent : {getcurrectData?.tdsPercent}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.tdsAmt || 0) !== Number(getcurrectData.tdsAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">TDS Amount : {formatAmountInINR(parseFloat(getcurrectData?.tdsAmount || 0))}</Box></Col>
                      </Row>
                     
                  
                     
                      
                     
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information :
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.approvalAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">

                        Requested Amount : {formatAmountInINR(parseFloat(getcurrectData?.approvalAmount))}
                        </Box>
                        </Col>
                      </Row>
                
                    <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="edited" />
                 
              
                 
                    {(role === "Manager" || role === "Admin") &&
                    <>
                  <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="edited"/>
                    </>
                  }
                  
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="border-2 p-0 pt-4 pb-2">
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                isConfirmed();
                closeModal();
              }}
            >
              ok
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                closeModal();
              }}
            >
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TdsDataChangeModal;
